import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import React__default from 'react';
import { TooltipTrigger, Focusable, DialogTrigger, Pressable } from 'react-aria-components';
import { Tooltip, TooltipPopover } from './Tooltip.js';

const ContentWithTooltip = ({ content, tooltipContent, tooltipProps, onOpenChange, isOpen, }) => {
    const isTouchDevice = matchMedia('(pointer:coarse)').matches;
    const tooltipComponent = (React__default.createElement(TooltipTrigger, { delay: 60, onOpenChange: onOpenChange, isOpen: isOpen },
        React__default.createElement(Focusable, null,
            React__default.createElement("div", null, content)),
        React__default.createElement(Tooltip, { ...tooltipProps, isOpen: isOpen }, tooltipContent)));
    const popoverComponent = (React__default.createElement(DialogTrigger, { onOpenChange: onOpenChange, isOpen: isOpen },
        React__default.createElement(Pressable, null,
            React__default.createElement("div", null, content)),
        React__default.createElement(TooltipPopover, { ...tooltipProps, isOpen: isOpen }, tooltipContent)));
    return isTouchDevice ? popoverComponent : tooltipComponent;
};
const InfoIconWithTooltip = ({ tooltipContent, tooltipProps, onOpenChange, isOpen, }) => (React__default.createElement(ContentWithTooltip, { content: React__default.createElement(InfoOutlineIcon, null), tooltipContent: tooltipContent, tooltipProps: tooltipProps, onOpenChange: onOpenChange, isOpen: isOpen }));

export { ContentWithTooltip, InfoIconWithTooltip };
//# sourceMappingURL=ContentWithTooltip.js.map
